export default __webpack_public_path__ + "static/media/cafe.c23a6a86.png";